import { useState, memo } from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'

import { Div as TrackedClickDiv } from 'reactSite/Analytics'

import * as S from './styled'

const BASE_SKETCHFAB_URL = 'https://sketchfab.com/models'

const SketchfabModel = ({ modelId, placeholder, trackingEvent }) => {
  const [shoudRenderModel, setShouldRenderModel] = useState(false)

  const embedOptions = {
    autostart: 1,
    camera: 0,
    ui_animations: 0,
    ui_infos: 0,
    ui_stop: 0,
    ui_inspector: 0,
    ui_watermark_link: 0,
    ui_watermark: 0,
    ui_ar: 0,
    ui_help: 0,
    ui_settings: 0,
    ui_vr: 0,
    ui_fullscreen: 1,
    ui_annotations: 0
  }

  const stringifiedEmbedOptions = qs.stringify(embedOptions)

  const modelUrl = `${BASE_SKETCHFAB_URL}/${modelId}/embed?${stringifiedEmbedOptions}`

  const renderPreviewImage = () => {
    const image = <img src={placeholder} alt={`Modelo 3d - ${modelId}`} />

    if (!trackingEvent) {
      return image
    }

    return <TrackedClickDiv {...trackingEvent}>{image}</TrackedClickDiv>
  }

  return (
    <S.SketchfabModel>
      {shoudRenderModel
        ? (
          <iframe
            frameBorder="0"
            allowvr="true"
            allowFullScreen="allowfullscreen"
            src={modelUrl}
          />
          )
        : (
            <div onClick={() => setShouldRenderModel(true)}>
              {renderPreviewImage()}
            </div>
          )}
    </S.SketchfabModel>
  )
}

SketchfabModel.propTypes = {
  modelId: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  trackingEvent: PropTypes.object
}

export default memo(SketchfabModel)
